import { Context, ObservableAction } from '../../../common'

export enum UpdatePlatform {
  LINUX = 'linux',
  WINDOWS = 'win32',
}

export interface UpdateDownload {
  platform: string
  link: string
}

export interface Update {
  version: string
  critical: boolean
  downloads: UpdateDownload[]
  releasedAt?: string
  changes?: string[]
}

export interface UpdatesService {
  getLatestUpdate(ctx: Context, currentVersion?: string): Promise<Update | undefined>
}

export interface UpdateDownloadService {
  readonly updateAvailable: ObservableAction<Update | undefined>

  apply(ctx: Context): Promise<void>
  download(ctx: Context, update: Update): Promise<void>
}
